import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { MOCKUP_URL, TEACHING_INSTRUCTOR_URL } from '../../data/images';
const closingSteps = ['Open your system.', 'Choose what you need.', 'Prepare your class.', 'Teach with confidence.'];

/** Section 15 — emotional close with a direct checkout button. */
export function FinalCtaSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-77" data-mp="cdz46uyxhk8c">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-78" data-mp="8df9rz5qoupw">
        <img src={TEACHING_INSTRUCTOR_URL} alt="A confident makeup instructor demonstrating a technique to her students in a bright academy classroom" width={1536} height={1024} loading="lazy" decoding="async" className="aspect-[3/2] w-full rounded-[22px] object-cover shadow-[0_40px_70px_-40px_rgba(34,30,36,0.55)]" data-id="element-79" data-mp="m4k0ucv1keom" />
        <div className="text-center lg:text-left" data-id="element-80" data-mp="2kqgz8nb30ko2">
          <h2 id="final-heading" className="font-display text-[2.2rem] font-bold leading-[1.05] text-brand-charcoal sm:text-[2.8rem]" data-id="element-81" data-mp="2ppjw3kgwrkky">
            You Became a Makeup Educator to Teach — <Accent data-id="element-82" data-mp="2zg65gwy17ev7">Not to Spend Your Nights Preparing Tomorrow's Class.</Accent>
          </h2>
          <p className="mt-5 text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-83" data-mp="21so261n534yl">
            You already have the makeup knowledge. Now give yourself the structure to teach it.
          </p>
          <ul className="mt-4 space-y-1 text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" role="list" data-id="element-84" data-mp="2bp97ko32mi2y">
            {closingSteps.map(step => <li key={step} data-id="element-85" data-mp="3n5r1ohj748mf">{step}</li>)}
          </ul>
        </div>
      </div>

      <p className="mt-16 text-center font-display text-[2.4rem] font-bold uppercase leading-[1.02] text-brand-charcoal sm:text-[3.4rem]" data-id="element-86" data-mp="3r72ibxk3djih">
        Less Time Preparing.
        <span className="block italic normal-case text-brand-plum" data-id="element-87" data-mp="1s0ho0d3b5uhe">More Time Teaching.</span>
      </p>

      <img src={MOCKUP_URL} alt="The complete Makeup Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-5xl" style={{
      filter: 'drop-shadow(0 30px 36px rgba(59, 27, 87, 0.18))'
    }} data-id="element-88" data-mp="1n5c1pd5zudss" />

      <div className="mx-auto mt-6 max-w-3xl text-center" data-id="element-89" data-mp="14d01ox2tbolt">
        <p className="mx-auto w-fit rounded-full border border-brand-plum/20 bg-white px-5 py-2 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-90" data-mp="14ekw8mp4n7jo">
          6 Core Volumes + 5 Extra Bonuses
        </p>
        <CtaBlock label="Start Teaching Without the Stress" note="One-Time Payment • Instant Digital Access • No Subscription" className="mt-8" data-id="element-91" data-mp="pnu4fenjc8gk" />

        <div className="mt-14 border-t border-brand-charcoal/12 pt-10" data-id="element-92" data-mp="kmoa5ce88d4x">
          <p className="font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal sm:text-[1.75rem]" data-id="element-93" data-mp="2wajdv52ntn8r">
            Your classes don't need to start <Accent data-id="element-94" data-mp="2nbo79rvpeb4x">from scratch.</Accent>
          </p>
          <TeachingFlow steps={['Open', 'Choose', 'Prepare', 'Teach']} className="mt-4" data-id="element-95" data-mp="2nczbfst29kwk" />
        </div>
      </div>
    </section>;
}